export default __webpack_public_path__ + "static/media/LInstagram.189df2dd.svg";